import { denormalize } from "normalizr";
import schemas from "../../utils/schemas";

export const getGenericFilterParams = (state, context) => {
  const items = state.genericFilterParams[context] ? state.genericFilterParams[context].genericFilterParams : null;

  const loading = items && items.loading ? true : false;
  const loaded = items && items.loaded ? true : false;
  const content = loaded ? denormalize(items.ids, schemas.genericFilterParams, state.entities) : [];

  return { loading, loaded, content };
};

export const getGenericFilterOperators = (state, context) => {
  const projectionState = state.genericFilterOperators[context]
    ? state.genericFilterOperators[context].genericFilterOperators
    : null;

  const loading = projectionState && projectionState.loading;
  const loaded = projectionState && projectionState.loaded ? true : false;
  const content = loaded ? denormalize(projectionState.ids, schemas.genericFilterOperators, state.entities) : [];

  return { loading, loaded, content };
};

export const getGenericFilterParamValues = (state, context, paramId) => {
  if (paramId === null) return { loading: false, loaded: false, content: null };

  const projectionState = state.genericFilterParamValues[context]
    ? state.genericFilterParamValues[context][paramId]
    : null;

  const loading = projectionState && projectionState.loading;
  const loaded = projectionState && projectionState.loaded ? true : false;
  const content = loaded ? denormalize(projectionState.ids, schemas.genericFilterParamValues, state.entities) : [];

  return { loading, loaded, content };
};
